module.exports = __webpack_public_path__ + "static/media/grason.a2eefe06.jpg";